import { SVGProps } from 'react'

function Collection(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="35" height="46" viewBox="0 0 35 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" y="13.2847" width="21.5" height="32.2143" stroke="currentColor" />
      <path d="M6.42856 12.0273V7.42773H27.8571V40.642H23.2653" stroke="currentColor" />
      <path d="M12.8571 5.59863V0.999023H34.2857V34.2133H29.6939" stroke="currentColor" />
      <rect x="4.52084" y="17.5199" width="5.65481" height="6.77089" stroke="currentColor" strokeWidth="1.04167" />
      <rect x="12.2589" y="17.5199" width="5.65481" height="6.77089" stroke="currentColor" strokeWidth="1.04167" />
      <rect x="4.52084" y="26.3734" width="5.65481" height="6.77089" stroke="currentColor" strokeWidth="1.04167" />
      <rect x="12.2589" y="26.3734" width="5.65481" height="6.77089" stroke="currentColor" strokeWidth="1.04167" />
      <rect x="4.52084" y="35.2288" width="5.65481" height="6.77089" stroke="currentColor" strokeWidth="1.04167" />
      <rect x="12.2589" y="35.2288" width="5.65481" height="6.77089" stroke="currentColor" strokeWidth="1.04167" />
    </svg>

  )
}

export default Collection
